import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ClientDashboard from './pages/ClientDashboard';
import EditTemplate from './pages/EditTemplate';
import FinancialTraining from './pages/FinancialTraining';
import ManagementTraining from './pages/ManagementTraining';
import BalanceSheetOverview from './pages/BalanceSheetOverview';
import FinancialPractice from './pages/FinancialPractice';
import RespondTemplate from './pages/RespondTemplate';
import OrganizationDetails from './pages/OrganizationDetails';
import UserResponses from './pages/UserResponses';
import ProtectedRoute from './components/auth/ProtectedRoute';
import RoleBasedDashboard from './components/auth/RoleBasedDashboard';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <RoleBasedDashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/client/dashboard" 
              element={
                <ProtectedRoute>
                  <ClientDashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/edit-template/:id" 
              element={
                <ProtectedRoute>
                  <EditTemplate />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/financial/welcome" 
              element={
                <ProtectedRoute>
                  <FinancialTraining />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/financial/overview" 
              element={
                <ProtectedRoute>
                  <BalanceSheetOverview />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/financial/practice" 
              element={
                <ProtectedRoute>
                  <FinancialPractice />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/organization/:orgId/user/:userId/welcome" 
              element={
                <ProtectedRoute>
                  <ManagementTraining />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/organization/:orgId/user/:userId/responses" 
              element={
                <ProtectedRoute>
                  <RespondTemplate />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/organization/:id" 
              element={
                <ProtectedRoute>
                  <OrganizationDetails />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/user-responses/:userId" 
              element={
                <ProtectedRoute>
                  <UserResponses />
                </ProtectedRoute>
              } 
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;